import { useOverviewContext } from "@features/overview-v2/hooks";
import {
  type TileDescriptor,
  type Layouts,
  type BreakpointName,
  TileType,
} from "@features/overview-v2/types";

import { NumberOfMetrics, TileModal } from "./tile-modal";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  readonly tile: TileDescriptor;
}

export const UpdateTileModal = ({ tile, isOpen, onClose }: Props) => {
  const { updateTiles } = useOverviewContext();

  return (
    <TileModal
      isOpen={isOpen}
      onClose={onClose}
      title="Update tile"
      initialValues={{
        ...tile,
        numberOfMetrics: tile.metric2Id
          ? NumberOfMetrics.TWO_METRICS
          : NumberOfMetrics.ONE_METRIC,
        metric2Filters: tile.metric2Filters ?? [],
      }}
      submitButtonText="SAVE"
      onSubmit={(values) => {
        updateTiles(
          {
            id: tile.id,
            update: {
              ...values,
              layouts: Object.keys(tile.layouts).reduce(
                (prev: Layouts, curr: string) => {
                  const k = curr as BreakpointName;
                  const l = tile.layouts[k];
                  return {
                    ...prev,
                    [k]: {
                      ...l,
                      height:
                        values.type !== TileType.METRIC && l.height === 1
                          ? 2
                          : l.height,
                      width:
                        values.type === TileType.METRIC && l.width === 2
                          ? 1
                          : l.width,
                    },
                  };
                },
                {} as Layouts,
              ),
            },
          },
          {
            successMessage: "Tile successfully updated.",
            errorMessage: "There was an error updating the tile.",
            onSuccess: () => onClose(),
          },
        );
      }}
    />
  );
};
